<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="30vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                设置呆料期
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="呆料期" prop="idleTime" required>
                    <el-input type="Number" v-model="form.idleTime" placeholder="请输入呆料期">
                        <template slot="append">天</template>
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if(this.$pub.isEmpty(this.form.idleTime)){
                    this.$message({message: '请输入呆料期', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form);
            },
        }
    }
</script>

